import { type ReactNode } from 'react'
import { RiffrecProvider as Riffrec } from 'riffrec'

interface RiffrecProviderProps {
  enabled: boolean
  children: ReactNode
}

/**
 * Wraps the app in the riffrec capture context when enabled. The visible
 * recorder button lives in the Layout footer (admin-only via the shared
 * feedback_capture_enabled prop) — this wrapper only provides the context.
 *
 * riffrec is local-first: sessions download as a zip in the admin's browser —
 * no endpoint, no key, nothing uploaded. The server-side gate is
 * RIFFREC_ENABLED + an admin session (see config/initializers/riffrec.rb and
 * InertiaController). Production builds additionally require ?riffrec=1 on the
 * URL (forceEnableParam).
 */
export default function RiffrecProvider({ enabled, children }: RiffrecProviderProps) {
  if (!enabled) return <>{children}</>

  return <Riffrec forceEnableParam>{children}</Riffrec>
}
